import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Typography from '../../../UniformComponents/Typography'

const colorList = ['#0DAAC9', '#33E1D5']

const Specification = ({ store: { specificationData } }) => (
    <div className="pp-summary-slide-container">
        <div className="pp-summary-slide-header">
            <div className="pp-summary-slide-header-text-container">
                <Typography type="tiny" color="primary">{i18n.t('s_tab_overview')}</Typography>

                <Typography color="white">Project specifications</Typography>
            </div>

            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 30 }} />
        </div>

        <div className="pp-summary-slide-content">
            <div className="pp-summary-slide-content-column">
                <div style={{ display: 'flex', gap: 30 }}>
                    <div style={{ height: 40, width: 40, borderRadius: 40, backgroundColor: '#0DAAC9', flexShrink: 0 }} />

                    <ul>
                        <li>
                            <Typography type="tiny">{specificationData.eventDates}</Typography>
                        </li>

                        <li>
                            <Typography type="tiny">{specificationData.fieldWorkDates}</Typography>
                        </li>
                    </ul>

                </div>

                <div style={{ display: 'flex', gap: 30 }}>
                    <div style={{ height: 40, width: 40, borderRadius: 40, backgroundColor: '#33E1D5', flexShrink: 0 }} />

                    <ul style={{ fontStyle: 'italic' }}>
                        <li>
                            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                        </li>

                        <li>
                            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                        </li>

                        <li>
                            <Typography type="tiny">{i18n.t('powerpoint.slide.auto-commentary')}</Typography>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="pp-summary-slide-content-column">
                {specificationData.respondentStats.map((stat, index) => (
                    <div style={{ display: 'flex', gap: 30 }}>
                        <div style={{ height: 40, width: 40, borderRadius: 40, backgroundColor: colorList[index], flexShrink: 0 }} />

                        <div>
                            <Typography type="tiny" color="white">{stat.respondentType}</Typography>

                            <ul>
                                <li>
                                    <Typography type="tiny">{stat.numberOfSentEmails}</Typography>
                                </li>

                                {stat.years.map((year) => (
                                    <li>
                                        <Typography type="tiny">{year}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
)

export default observer(Specification)
